import classNames from 'classnames';

import Footer, { FooterTheme } from './Footer';
import { NonLoggedMenu } from './NonLoggedHeader';
import { useNonLoggedFooterStyles } from './NonLoggedFooter.styles';

export default function NonLoggedFooter() {
  const { styles } = useNonLoggedFooterStyles();
  return (
    <>
      <div className={styles.nonLoggedFooterLinksAbove}>
        <div
          className={classNames(styles.loggedFooterLinks, 'hide-xl-and-bigger')}
        >
          <NonLoggedMenu />
        </div>
      </div>
      <Footer theme={FooterTheme.LIGHT} />
    </>
  );
}
